<ion-content>
  <ion-row class="p-0">
    <ion-col *ngIf="!mobileResponsiveService.ifIsIosMobOrTabDevice" size-sm="12" size-md="6" class="p-0 leftSide text-left welcome-col isShowDesktopView">
      <div class="rightSideCard">
        <ion-row>
          <ion-col size="12" class="mt_0ForMobile">
            <div class="fs-24 fs_18ForMobile font_semibold fs_14ForMobile">
              Welcome to
              <span class="fs-30 font_bold advikTextColor fs_14ForMobile">ADVIK (DWM+)</span>
            </div>
          </ion-col>
          <!-- <ion-col size="12" class="mt-10">
            <div class="formLabelRegularfs18 font_semibold fs_12ForMobile">A real-time and intelligent talent management solution. It helps address all people challenges through application of various people modules. We are delighted to be of service to you.</div>
          </ion-col> -->
          <!-- <ion-col size="12">
            <div class="fs-20 font_semibold fs_14ForMobile">FOR HR BY HR</div>
          </ion-col> -->
          <!-- <ion-col size="12" class="mt-10 text-center">
            <img src="././assets/icon/loginRightNetwork.png" class="h350 headingImg">
          </ion-col> -->
        </ion-row>
      </div>
      <div>
        <div class="values-wrapper">
          <div class="values-container">
            <div class="center-hub">
              <div class="hub-icon">
                <img src="././assets/icon/values_icon.svg" class="hub-icons" />
              </div>
              <div class="hub-title">ADVIK VALUES</div>
            </div>

            <div class="segment segment-1" style="--i: 0">
              <div class="segment-body segment-body-0">
                <img src="././assets/icon/ico_img_04.png" class="segment-icons" />
                <div class="segment-text">
                  AIM FOR
                  <br />
                  PERFECTION
                </div>
              </div>
            </div>
            <div class="segment segment-2" style="--i: 1">
              <div class="segment-body segment-body-1">
                <img src="././assets/icon/ico_img_06.png" class="segment-icons" />
                <div class="segment-text">PASSION</div>
              </div>
            </div>
            <div class="segment segment-3" style="--i: 2">
              <div class="segment-body segment-body-2">
                <img src="././assets/icon/ico_img_01.png" class="segment-icons" />
                <div class="segment-text">SINCERITY</div>
              </div>
            </div>
            <div class="segment segment-4" style="--i: 3">
              <div class="segment-body segment-body-3">
                <img src="././assets/icon/ico_img_03.png" class="segment-icons" />
                <div class="segment-text">HUMILITY</div>
              </div>
            </div>
            <div class="segment segment-5" style="--i: 4">
              <div class="segment-body segment-body-4">
                <img src="././assets/icon/ico_img_05.png" class="segment-icons" />
                <div class="segment-text">INTEGRITY</div>
              </div>
            </div>
            <div class="segment segment-6" style="--i: 5">
              <div class="segment-body segment-body-5">
                <img src="././assets/icon/ico_img_07.png" class="segment-icons" />
                <div class="segment-text">
                  RESPECT FOR
                  <br />
                  INDIVIDUAL
                </div>
              </div>
            </div>
            <div class="segment segment-7" style="--i: 6">
              <div class="segment-body segment-body-6">
                <img src="././assets/icon/ico_img_02.png" class="segment-icons" />
                <div class="segment-text">
                  SELF
                  <br />
                  DISCIPLINE
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ion-col>
    <ion-col size class="p-0" class="rightSide login-col">
      <div class="loginCard">
        <ion-row>
          <ion-col size="12" class="text-center">
            <img src="././assets/icon/logo_advik.png" [style]="{'max-height':'65px', 'margin': '3px 7px'}" />
            <img src="././assets/icon/Phiedge-logo_HRMS.png" [style]="{'max-height':'65px', 'margin': '3px 7px'}" />
          </ion-col>
          <ion-col size="12" class="mt-20 text-center mt_0ForMobile">
            <div class="formLabelSemiBoldfs24 fs_14ForMobile" *ngIf="!otpSent">SIGN IN</div>
            <div class="formLabelSemiBoldfs24 fs_14ForMobile mb-15" *ngIf="otpSent">OTP Verification</div>
          </ion-col>
        </ion-row>
        <div *ngIf="!otpSent">
          <form [formGroup]="loginForm" (ngSubmit)="onClickLogin(null)">
            <ion-row>
              <ion-col size="12" class="mt-10">
                <img src="././assets/icon/emailIcon.svg" class="mailIcon" />
                <input type="text" placeholder="Email ID" class="inputstyle font_regular olnone form-control" autocomplete="off" formControlName="email" />
              </ion-col>
              <label class="red-cl font_regular fs-12 fs_11ForMobile pl-5" *ngIf="formSubmitted && loginForm.controls['email'].hasError('required')">Email ID is required</label>
              <label class="red-cl font_regular fs-12 fs_11ForMobile pl-5" *ngIf="formSubmitted && loginForm.controls['email'].hasError('pattern')">Please Enter Correct Email ID</label>
              <ion-col size="12" class="mt-10">
                <img src="././assets/icon/lockIcon.svg" class="mailIcon" />
                <input type="{{passwordShow}}" placeholder="Password" class="inputstyle font_regular olnone form-control" autocomplete="off" formControlName="password" />
                <img src="././assets/icon/eye-show.png" class="eyeIcon cp" (click)="onEyeClick()" *ngIf="!showpwd" />
                <img src="././assets/icon/eye-hide.png" class="eyeIcon cp" (click)="onEyeClick()" *ngIf="showpwd" />
              </ion-col>
              <label class="red-cl font_regular fs-12 fs_11ForMobile pl-5" *ngIf="formSubmitted && loginForm.controls['password'].hasError('required')">Password is required</label>
            </ion-row>

            <ion-row class="mt-15 phi-justify-content-center">
              <ion-col size>
                <button type="submit" class="text-center fs-16 fs_14ForMobile font_semibold login-btn fs_14ForMobile">Login</button>
              </ion-col>
              <ion-col size="auto" *ngIf="platform && (platform !== 'web')">
                <button type="button" class="biometric-login-btn h-100 phi-flex-wrap-center" (click)="tryBiometricAutoLogin()">
                  <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
                    <path d="M63.28 202a15.29 15.29 0 01-7.7-2 14.84 14.84 0 01-5.52-20.46C69.34 147.36 128 72.25 256 72.25c55.47 0 104.12 14.57 144.53 43.29 33.26 23.57 51.9 50.25 60.78 63.1a14.79 14.79 0 01-4 20.79 15.52 15.52 0 01-21.24-4C420 172.32 371 102 256 102c-112.25 0-163 64.71-179.53 92.46A15 15 0 0163.28 202z" />
                    <path d="M320.49 496a15.31 15.31 0 01-3.79-.43c-92.85-23-127.52-115.82-128.93-119.68l-.22-.85c-.76-2.68-19.39-66.33 9.21-103.61 13.11-17 33.05-25.72 59.38-25.72 24.48 0 42.14 7.61 54.28 23.36 10 12.86 14 28.72 17.87 44 8.13 31.82 14 48.53 47.79 50.25 14.84.75 24.59-7.93 30.12-15.32 14.95-20.15 17.55-53 6.28-82C398 228.57 346.61 158 256 158c-38.68 0-74.22 12.43-102.72 35.79-23.59 19.35-42.28 46.67-51.28 74.75-16.69 52.28 5.2 134.46 5.41 135.21A14.83 14.83 0 0196.54 422a15.39 15.39 0 01-18.74-10.6c-1-3.75-24.38-91.4-5.1-151.82 21-65.47 85.81-131.47 183.33-131.47 45.07 0 87.65 15.32 123.19 44.25 27.52 22.5 50 52.72 61.76 82.93 14.95 38.57 10.94 81.86-10.19 110.14-14.08 18.86-34.13 28.72-56.34 27.65-57.86-2.9-68.26-43.29-75.84-72.75-7.8-30.22-12.79-44.79-42.58-44.79-16.36 0-27.85 4.5-35 13.82-9.75 12.75-10.51 32.68-9.43 47.14a152.44 152.44 0 005.1 29.79c2.38 6 33.37 82 107.59 100.39a14.88 14.88 0 0111 18.11 15.36 15.36 0 01-14.8 11.21z" />
                    <path d="M201.31 489.14a15.5 15.5 0 01-11.16-4.71c-37.16-39-58.18-82.61-66.09-137.14V347c-4.44-36.1 2.06-87.21 33.91-122.35 23.51-25.93 56.56-39.11 98.06-39.11 49.08 0 87.65 22.82 111.7 65.89 17.45 31.29 20.91 62.47 21 63.75a15.07 15.07 0 01-13.65 16.4 15.26 15.26 0 01-16.79-13.29A154 154 0 00340.43 265c-18.64-32.89-47-49.61-84.51-49.61-32.4 0-57.75 9.75-75.19 29-25.14 27.75-30 70.5-26.55 98.78 6.93 48.22 25.46 86.58 58.18 120.86a14.7 14.7 0 01-.76 21.11 15.44 15.44 0 01-10.29 4z" />
                    <path d="M372.5 446.18c-32.5 0-60.13-9-82.24-26.89-44.42-35.79-49.4-94.08-49.62-96.54a15.27 15.27 0 0130.45-2.36c.11.86 4.55 48.54 38.79 76 20.26 16.18 47.34 22.6 80.71 18.85a15.2 15.2 0 0116.91 13.18 14.92 14.92 0 01-13.44 16.5 187 187 0 01-21.56 1.26zM398.18 48.79C385.5 40.54 340.54 16 256 16c-88.74 0-133.81 27.11-143.78 34a11.59 11.59 0 00-1.84 1.4.36.36 0 01-.22.1 14.87 14.87 0 00-5.09 11.15 15.06 15.06 0 0015.31 14.85 15.56 15.56 0 008.88-2.79c.43-.32 39.22-28.82 126.77-28.82S382.58 74.29 383 74.5a15.25 15.25 0 009.21 3 15.06 15.06 0 0015.29-14.89 14.9 14.9 0 00-9.32-13.82z" />
                  </svg>
                </button>
              </ion-col>
            </ion-row>
          </form>
        </div>

        <div *ngIf="otpSent" class="otp-card">
          <h2 class="title mb-10">Enter OTP</h2>
          <p class="subtitle">
            We’ve sent a code to
            <b>{{ userEmailOrPhone }}</b>
          </p>

          <div class="otp-inputs" (paste)="handlePaste($event)">
            <input autocomplete="off" type="number" (input)="onOtpInput($event, 0)" [(ngModel)]="otpDigits[0]" name="d1" (input)="moveNext($event, 0)" />
            <input autocomplete="off" type="number" (input)="onOtpInput($event, 1)" [(ngModel)]="otpDigits[1]" name="d2" (input)="moveNext($event, 1)" />
            <input autocomplete="off" type="number" (input)="onOtpInput($event, 2)" [(ngModel)]="otpDigits[2]" name="d3" (input)="moveNext($event, 2)" />
            <input autocomplete="off" type="number" (input)="onOtpInput($event, 3)" [(ngModel)]="otpDigits[3]" name="d4" (input)="moveNext($event, 3)" />
            <input autocomplete="off" type="number" (input)="onOtpInput($event, 4)" [(ngModel)]="otpDigits[4]" name="d5" (input)="moveNext($event, 4)" />
            <input autocomplete="off" type="number" (input)="onOtpInput($event, 5)" [(ngModel)]="otpDigits[5]" name="d6" (input)="moveNext($event, 5)" />
          </div>

          <button class="send-btn" (click)="verifyOtp()">Verify</button>

          <div class="resend-section">
            <span *ngIf="resendCountdown > 0">Resend in {{ resendCountdown }}s</span>
            <a *ngIf="resendCountdown === 0" (click)="sendOtp()">Resend Code</a>
          </div>

          <button class="change-email" type="button" (click)="reset()">Change Email</button>
        </div>
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="6" size-xs="12"></ion-col>
          <ion-col size-sm="12" size-md="12" size-lg="6" size-xs="12" class="text-right" *ngIf="!otpSent">
            <label class="fs-16 fs_14ForMobile font_medium cp forgotPassword" (click)="onClickForgotPassword()">Forgot Password?</label>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="!otpSent">
          <ion-col size="12">
            <div class="divider">
              <span>OR</span>
            </div>
          </ion-col>

          <ion-col>
            <!-- <div id="google-button" style="display: flex; justify-content: center;"> google</div> -->
            <!-- <div style="display: flex; gap: 10px; justify-content: center; margin-top: 20px;">              
              <div id="google-button" style="flex: 1;">Google</div>
              <button type="button" class="otp-button btn btn-outline-primary" (click)="sendOtp()">Sign in with OTP</button>
            </div> -->
            <div class="auth-buttons">
              <!-- <div id="google-button" *ngIf="platform && (platform === 'web')" class="auth-btn"></div> -->

              <!-- <button *ngIf="platform && (platform === 'android')" expand="block" type="button"
              class="google-style-btn pl-20 pr-20" (click)="signInWithGoogleForMobileOnly()">
              <ion-icon name="logo-google" slot="start" class="google-icon-color"></ion-icon>Sign in with Google
            </button> -->

              <!-- <button expand="block" type="button" class="google-style-btn pl-20 pr-20" (click)="signInWithGoogleForMobileOnly()">
              <ion-icon name="logo-google" slot="start" class="google-icon-color"></ion-icon>Sign in with Google
            </button> -->

              <button type="button" class="google-style-btn pl-20 pr-20" (click)="sendOtp()">
                <img src="assets/icon/emailIcon.svg" alt="OTP Icon" />
                <span>Sign in with OTP</span>
              </button>
            </div>

            <!-- OTP Modal -->
          </ion-col>
        </ion-row>
      </div>

      <ion-row>
        <ion-col size="12" class="d-flex justify-content-flex-end">
          <div class="bottomPosFixed">
            <div class="pl-10 fs-10 font_regular text_gray">Powered By:</div>
            <img class="powerdByIcon" src="././assets/icon/Phiedge-logo_HRMS.png" />
          </div>
        </ion-col>
      </ion-row>
    </ion-col>
  </ion-row>
</ion-content>
